import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import './UserCreate.css';
import { toInitialDateTime, isValidDateTime } from '../components/DateTimeInputBR';

const StoreEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { company, store, scrollY } = location.state || {};
    const backUrl = scrollY ? `/users?scrollY=${scrollY}` : '/users';

    const [storeDisplayName, setStoreDisplayName] = useState(store?.store_display_name || '');
    const [appVersionName, setAppVersionName] = useState(store?.app_version_name || 'default');
    // o setter saiu com o campo (§2.7): o valor e lido no submit e reenviado igual
    const [unlockDate] = useState(toInitialDateTime(store?.unlock_date));
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (!store?.store_id || !company?.id) {
            setMessage({ type: 'error', text: 'Loja não identificada. Volte e tente novamente.' });
            return;
        }
        if (!storeDisplayName.trim()) {
            setMessage({ type: 'error', text: 'Preencha o nome de exibição.' });
            return;
        }

        const ud = (unlockDate || '').trim();
        if (ud && !isValidDateTime(ud)) {
            setMessage({ type: 'error', text: 'Data final de aquecimento inválida. Use o formato AAAA-MM-DD HH:MM:SS (ex.: 2026-07-16 00:00:00).' });
            return;
        }

        try {
            setSubmitting(true);
            const payload = {
                company_id: company.id,
                store_id: store.store_id,
                store_display_name: storeDisplayName.trim(),
                app_version_name: appVersionName,
            };
            if (ud) {
                payload.unlock_date = ud;
            } else if (store?.unlock_date) {
                // tinha valor e agora está vazio => limpar (cai na cascata da empresa)
                payload.clear_unlock_date = true;
            }
            const result = await apiService.updateStore(payload);

            if (result.success) {
                setMessage({ type: 'success', text: `Loja "${storeDisplayName.trim()}" atualizada com sucesso!` });
            } else {
                setMessage({ type: 'error', text: result.message || 'Erro ao editar loja.' });
            }
        } catch (err) {
            setMessage({ type: 'error', text: 'Erro ao editar loja. Tente novamente.' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="user-create">
            <div className="user-create-header">
                <button className="btn-back" onClick={() => navigate(backUrl)}>
                    &#8592; Voltar
                </button>
                <h1>Editar Loja</h1>
            </div>

            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    {message.text}
                </div>
            )}

            <form className="user-create-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="company">Empresa</label>
                        <input id="company" type="text" value={company?.name || ''} disabled className="form-input" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="storeName">Nome da Loja</label>
                        <input id="storeName" type="text" value={store?.store_name || ''} disabled className="form-input" />
                        <span className="field-hint">O nome interno da loja não pode ser alterado.</span>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="storeDisplayName">Nome de Exibição</label>
                        <input
                            id="storeDisplayName"
                            type="text"
                            value={storeDisplayName}
                            onChange={(e) => setStoreDisplayName(e.target.value)}
                            className="form-input"
                            placeholder="ex: Loja Centro"
                            autoFocus
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="appVersionName">Versão do app</label>
                        <select
                            id="appVersionName"
                            value={appVersionName}
                            onChange={(e) => setAppVersionName(e.target.value)}
                            className="form-input"
                        >
                            <option value="default">default</option>
                            <option value="gamification">gamification</option>
                        </select>
                        <span className="field-hint">
                            Vale para todos os vendedores da loja que não tenham uma versão específica.
                        </span>
                    </div>
                </div>

                {/* ------------------------------------------------------------------------------------
                        "Data final de aquecimento" (`unlock_date`) SAIU DA TELA — §2.7 do plano de Fases.

                        Aquecimento é uma FASE, não um atributo de loja/empresa: quem decide quando o
                        placar abre é a fase com `locks_scoreboard`, e o /auth passa a computar o
                        `unlock_date` a partir dela (`scoreboard_open_on`).

                        O CAMPO SÓ SAIU DA TELA — a coluna continua no banco e continua VENCENDO quem
                        não está em programa, então nada muda para as 9 lojas que têm data hoje. O
                        estado é preservado no submit: o valor atual é reenviado igual, e nunca é
                        limpo por omissão.

                        Para uma loja que precise calibrar de agora em diante, o caminho é criar
                        programa com fase de Aquecimento (que trava). Se for preciso o campo de volta
                        antes disso, é só devolver este bloco — o back-end continua aceitando.
                        ------------------------------------------------------------------------ */}

                <div className="form-actions">
                    <button type="button" className="btn btn-cancel" onClick={() => navigate(backUrl)}>
                        Cancelar
                    </button>
                    <button type="submit" className="btn btn-submit" disabled={submitting}>
                        {submitting ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default StoreEdit;
